import { Button, ButtonTheme } from 'components/Button';
import { TextField } from 'components/Field/TextField';
import { ICONS } from 'components/Icon';
import { useSelector } from 'hooks/useSelector';
import { noop } from 'lodash';
import * as React from 'react';
import { useState } from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import {
  AUTHENTICATE,
  REQUEST_PASSWORD_RESET,
  RESET_AUTH_STEP,
} from 'store/actions';
import { selectUserEmailWithAuthStepEmail } from 'store/auth/selectors';

import { Card } from 'components/Card';
import { useForceUpdate } from 'hooks/useForceUpdate';
import { styles } from './styles';
import { UserChip } from './UserChip';

export const Password: React.FC = () => {
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const email = useSelector(selectUserEmailWithAuthStepEmail);
  const autoFocusOnNextRenderRef = React.useRef<boolean>(true);
  const [password, setPassword] = useState('');

  const handleBack = () => dispatch(RESET_AUTH_STEP());
  const handleResetPassword = () => {
    dispatch(REQUEST_PASSWORD_RESET.request());
    autoFocusOnNextRenderRef.current = false;
    forceUpdate();
  };
  const handleSubmit = () => {
    if (password) {
      dispatch(AUTHENTICATE.request({ password }));
    }
  };

  const autoFocus = autoFocusOnNextRenderRef.current;
  autoFocusOnNextRenderRef.current = true;

  return (
    <>
      <UserChip />
      <TextField
        inputMode="email"
        autoComplete="email"
        onChange={noop}
        value={email}
        containerStyle={{ left: -999, position: 'absolute', top: -999 }}
      />
      <Card
        label="Please enter your password"
        style={styles.textFieldContainer}
        explanationLinkText="Reset your password"
        onExplanationLinkPress={handleResetPassword}
      >
        <TextField
          placeholder="Your Password"
          onChange={setPassword}
          secureTextEntry
          autoComplete="password"
          autoCapitalize="none"
          autoCorrect={false}
          onSubmitEditing={handleSubmit}
          returnKeyType="next"
          enablesReturnKeyAutomatically
          onChangeDebounceMs={0}
          // Will re-focus field if an API error comes back
          autoFocusEveryRender={autoFocus}
          key={autoFocus ? 'withAutoFocus' : 'withoutAutoFocus'}
        />
      </Card>
      <View style={styles.buttonContainer}>
        <Button
          buttonTheme={ButtonTheme.secondary}
          onPress={handleBack}
          text="Back"
          marginRight
        />
        <Button
          disabled={!password}
          icon={ICONS.ChevronRightSolid}
          onPress={handleSubmit}
          text="Next"
        />
      </View>
    </>
  );
};
